import { AdaptiveSheet } from '../common/AdaptiveSheet';
import {
  DefensePlanAssignForm,
  type DefensePlanAssignFormProps,
  type AssignBundleTarget,
} from './DefensePlanAssignForm.web';

export type { AssignBundleTarget };

// Phone (and any non-desktop-shell caller) host for DefensePlanAssignForm:
// an AdaptiveSheet around the same form the desktop shell puts in a
// CompanionPanel instead (DefensePlanPanel.web.tsx, DefensePlanViewer.web.tsx
// branch on useDesktopShell() to choose between this and a CompanionPanel).
// DefensePlanViewerCard.web.tsx — phone-only — always uses this one.
export function DefensePlanAssignSheet(props: DefensePlanAssignFormProps & { visible: boolean }) {
  const { visible, onClose, ...formProps } = props;
  return (
    <AdaptiveSheet isOpen={visible} onRequestClose={onClose} onDismiss={onClose} dialogWidth={480}>
      <AdaptiveSheet.ScrollView testID="assign-sheet">
        <DefensePlanAssignForm {...formProps} onClose={onClose} />
      </AdaptiveSheet.ScrollView>
    </AdaptiveSheet>
  );
}
